import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-acdc-gis-utils',
  template: `
    <p>
      acdc-gis-utils works!
    </p>
  `,
  styles: []
})
export class AcdcGisUtilsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
